import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModules } from 'src/app/shared.modules';
import { DialogSimpleComponent } from './dialog-simple.component';

@NgModule({
  declarations: [DialogSimpleComponent],
  imports: [
    CommonModule,
    SharedModules
  ]
})
export class DialogSimpleModule { }
